import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../../utils/AuthContext';
import { toastSuccess } from '../../../utils/toastManager';
import { formButtons, formContentForm } from '../formComponents';

function Post({ id }) {
  const { auth } = useAuthContext();

  // form inputs
  const [formCoverImageURL, setFormCoverImageURL] = useState('');
  const [formTitle, setFormTitle] = useState('');
  const [formDate, setFormDate] = useState('');
  const [formContent, setFormContent] = useState([]);

  async function fetchRecords() {
    if (!auth || !auth.currentUser) return;

    // fetch records
    fetch('/.netlify/functions/admin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: auth.currentUser.email,
        payload: auth.currentUser.uid,
        route: 'FIND',
        params: {
          ids: [id],
          collectionName: 'posts',
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setFormCoverImageURL(response.records[0]?.coverImageURL || '');
        setFormTitle(response.records[0]?.title || '');
        setFormDate(response.records[0]?.date || '');
        setFormContent(response.records[0]?.content || []);
      });
  }
  useEffect(() => {
    fetchRecords();
  }, [auth?.currentUser, id]);

  function handleSave(e) {
    e.preventDefault();

    fetch('/.netlify/functions/admin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: auth.currentUser.email,
        payload: auth.currentUser.uid,
        route: 'UPDATE_ONE',
        params: {
          id,
          valuesObj: {
            coverImageURL: formCoverImageURL,
            date: formDate,
            title: formTitle,
            content: formContent,
          },
          collectionName: 'posts',
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.message === 'success') toastSuccess('Success!');
      });
  }

  function handleDelete() {
    // e.preventDefault();

    fetch('/.netlify/functions/admin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: auth.currentUser.email,
        payload: auth.currentUser.uid,
        route: 'DELETE_ONE',
        params: {
          id,
          collectionName: 'posts',
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.message === 'success') toastSuccess('Deleted!');
      });
  }

  function detailsForm() {
    return (
      <form className="bg-color-2 px-4 py-2 text-white">
        <div className="grid grid-cols-[1fr,2fr] pt-4">
          <label className="mb-2 mr-2 text-right text-gray-300" htmlFor="id">
            ID:
          </label>
          <input
            className="mb-2 rounded bg-color-2 outline-none"
            type="text"
            id="id"
            name="id"
            value={id}
            readOnly
          />
          <label
            className="mr-2 text-right text-gray-300"
            htmlFor="formCoverImageURL"
          >
            Cover Image URL:
          </label>
          <div className="flex flex-col">
            <input
              className={`
                mb-2 rounded bg-color-1 px-1

                focus:outline-none focus:ring-2 focus:ring-color-5
              `}
              type="string"
              id="formCoverImageURL"
              name="formCoverImageURL"
              defaultValue={formCoverImageURL}
              onChange={(e) => setFormCoverImageURL(e.target.value)}
            />
            {formCoverImageURL && (
              <img
                className="mb-2 w-[200px] rounded"
                alt="formCoverImageURL"
                src={`${formCoverImageURL}/m/200x0`}
              />
            )}
          </div>
          <label className="mr-2 text-right text-gray-300" htmlFor="formTitle">
            Title:
          </label>
          <input
            className={`
              mb-2 rounded bg-color-1 px-1

              focus:outline-none focus:ring-2 focus:ring-color-5
            `}
            type="string"
            id="formTitle"
            name="formTitle"
            defaultValue={formTitle}
            onChange={(e) => setFormTitle(e.target.value)}
          />
          <label className="mr-2 text-right text-gray-300" htmlFor="formDate">
            Date:
          </label>
          <input
            className={`
              mb-2 rounded bg-color-1 px-1

              focus:outline-none focus:ring-2 focus:ring-color-5
            `}
            type="date"
            id="date"
            name="formDate"
            defaultValue={formDate}
            onChange={(e) => setFormDate(e.target.value)}
          />

          {formContentForm(formContent, setFormContent)}
        </div>
        {formButtons(id, handleDelete, handleSave)}
      </form>
    );
  }

  return (
    <div
      className={`
        max-h-[95vh] min-w-[500px] overflow-y-scroll rounded border-4 border-color-4 bg-white pt-4
      `}
    >
      <h1 className="px-4">Post Details</h1>
      {detailsForm()}
    </div>
  );
}

export default Post;
